import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import sharedMessages from "../../../../shared-messages";
import { Password as NewPasswordField } from "../../shared/fields";

const NonCoppaResetPasswordFormFields = ({ username }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <NewPasswordField
        email={username}
        label={formatMessage(sharedMessages.newPassword)}
        id="new-password"
        name="newPassword"
      />
    </>
  );
};

NonCoppaResetPasswordFormFields.propTypes = {
  username: PropTypes.string.isRequired
};

export default NonCoppaResetPasswordFormFields;
